import { Controller } from "stimulus";
import MicroModal from "micromodal";

export default class extends Controller {
    static targets = ["container"];

    connect() {
        MicroModal.init({ disableScroll: true });
        this._scrollIfNeeded();
    }

    showLoader() {
        this.containerTarget.classList.add("loading");
    }

    _scrollIfNeeded() {
        if (window.location.search === "" || window.location.search === "?") return;
        window.scrollTo({ top: 480, behavior: "smooth" });
    }
}
